export default {
  0: {
    layer: 0,
    size: 48,
    maxColumns: 8,
    layerStyle:
    {
      textAlign: 'center',
      backgroundColor: '#777777',
      color: '#AAAAAA',
    },
    headerText: "Select your character's top fifteen personal values",
  },
  1: {
    layer: 1,
    size: 15,
    maxColumns: 5,
    layerStyle:
    {
      textAlign: 'center',
      backgroundColor: '#226622',
      color: '#BBBBBB',
    },
    headerText: 'Select the seven most important values',
  },
  2: {
    layer: 2,
    size: 7,
    maxColumns: 3,
    layerStyle:
    {
      textAlign: 'center',
      backgroundColor: '#553388',
      color: '#BBBBBB',
    },
    headerText: 'Pick the top three values',
  },
  3: {
    layer: 3,
    size: 3,
    maxColumns: 2,
    layerStyle:
    {
      textAlign: 'center',
      backgroundColor: '#5555aa',
      color: '#cccccc',
    },
    headerText: 'Pick the most important value of all',
  },
  4: {
    layer: 4,
    size: 1,
    maxColumns: 1,
    layerStyle:
    {
      textAlign: 'center',
      backgroundColor: '#9977cc',
      color: '#dddddd',
    },
    headerText: 'These are the values that define your character',
  },
  5: {
    layer: 5,
    size: 0,
    maxColumns: 0,
    layerStyle:
    {
      textAlign: 'center',
      backgroundColor: '#777777',
      color: '#AAAAAA',
    },
    headerText: 'These are the values that define your character',
  },
};



// WEBPACK FOOTER //
// ./src/fixtures/selectionLayers.js